import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@material-ui/core/Grid'
import FormDatePicker from '../../../components/DatePicker';
import FormControl from '@material-ui/core/FormControl';
import { lightTheme } from "../../../SharedComponents/SharedComponentStyles";
import { Button, ThemeProvider } from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import MaterialTable from "material-table";
import Select from '@material-ui/core/Select';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios'
import Alert from '@material-ui/lab/Alert';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector, useDispatch } from "react-redux";

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const apirpt = axios.create({
    baseURL: `WorkerReport`
})

const api = axios.create({
    baseURL: 'MasterDetails'
})
function GSPDReport() {
    //for progress
    const [openLoader, setopenLoader] = useState(false);
    //for alert
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [openType, setopenType] = useState("");
    //const [alertsuccess, setalertsuccess] = useState("Success");
    const [alerterror, setalerterror] = useState("Alert");
    //const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    

    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }

    function handleClose() {
        setopen(false);
    }

    var columns = [
        { title: "MRP Controller", field: "mrpcontroller" },
        { title: "Wage Group", field: "wageGroup" },
        { title: "Worker", field: "worker" },
        { title: "RunTime", field: "runtime" },
        { title: "Setup Time", field: "setupTime" },
        { title: "Add Setup Time", field: "addSetUpTime" },
        { title: "Extra Cost", field: "extraCost" },
        { title: "Output(SMH)", field: "smh" },
        { title: "Unplanned Idle Time", field: "uit" },
        { title: "Unplanned Idle Time(Due to No Work)", field: "uitNw" },
        { title: "Planned Idle Time", field: "pit" },
        { title: "Total Idle Time", field: "tit" },
        { title: "OverTime", field: "ot" },
        { title: "Input(AMH)", field: "amh" },
        { title: "IHF Time", field: "ihf" },
        { title: "Effective Input Hours", field: "effAmh" },
        { title: "Unplanned Idle Time %", field: "uitPer" },
        { title: "PI Index-1", field: "piindex1" },
        { title: "PI Index-2", field: "piindex2" },
        { title: "PI Index-3", field: "piindex3" },
        { title: "PI Index-4", field: "piindex4" },       
    ]

    const [mrp, setmrp] = useState([]);
    const [data, setData] = useState([]); //table data
    const [mrpController, setMrpController] = React.useState('');
    const [wageGroup, setWageGroup] = React.useState('');
    const [mrplookup, setmrplookup] = useState([]);
    const [wage, setwage] = useState([]);
    const [employee, setemployee] = useState([]);
    const [employeelookup, setemployeelookup] = useState([]);
    const [worker, setWorker] = React.useState('');
    const [fromdate, setFromdate] = useState(null);
    const [todate, setTodate] = useState(null);

    const handleChange = (event) => {
        setMrpController(event.target.value);
    };

    const handleChangeWageGroup = (event) => {
        setWageGroup(event.target.value);
    };

    const handleChangeWorker = (event) => {
        setWorker(event.target.value);
    };

    //for error handling
    const [iserror, setIserror] = useState(false)
    const [errorMessages, setErrorMessages] = useState([])

    const SearchTable = (event) => {
        if (fromdate != null && todate != null) {
            getGSPDReport();
            getMRP();
            getEmployees();
            GetWages();
        }
        else {
            getMRP();
            getEmployees();
            GetWages();
            //alert("Please select From Date and To Date for fetching report details!");
            showMsg(true, "Please select From Date and To Date for fetching report details!", alerterrorclass, alerterror);
        }
    };

    function dateChangeEvent(dateValue, label) {
        if (label === "From Date") {
            if (todate !== null) {
                if ((Date.parse(dateValue) > Date.parse(todate))) {
                    showMsg(true, "From date should be less than To date", alerterrorclass, alerterror);
                    setFromdate(null);
                }
                else {
                    setFromdate(dateValue);
                }
            }
            else {
                setFromdate(dateValue);
            }
        }
        else if (label === "To Date") {
            //setTodate(dateValue);
            if ((Date.parse(fromdate) > Date.parse(dateValue))) {
                showMsg(true, "From date should be greater than To date", alerterrorclass, alerterror);
                setTodate(null);
            }
            else {
                setTodate(dateValue);
            }
        }
    }

    function GetWages() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getTblMstWageGroup_Rpt/',{
            headers: headers
        })
            .then(res => {
                setwage(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. : WageGroup")
            })
    }

    function getMRP() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getTblMstMrpcontroller/',{
            headers: headers
        })
            .then(res => {
              //  console.log("inside api");
                setmrp(res.data);
                var obj = res.data.reduce(function (acc, cur, i) {
                    acc[cur.mrpcontrollerId] = cur.mrpcontroller;
                    return acc;
                }, {});
                setmrplookup(obj);
            })
            .catch(error => {
                console.log("Error in hitting api at page load.")
            })
    }

    function getEmployees() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getAllEmployeeWorkers/',{
            headers: headers,
        })
            .then(res => {
                setemployee(res.data);
                var obj = res.data.reduce(function (acc, cur, i) {
                    acc[cur.employeeId] = cur.empName;
                    return acc;
                }, {});
                setemployeelookup(obj);
            })
            .catch(error => {
                console.log("Error in hitting api at page load.")
            })
    }

    function getGSPDReport() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        setopenLoader(true);
        let slipDet = {
            FromDate: fromdate,
            ToDate: todate,
            MrpcontrollerId: Number(mrpController),
            WageGroupId: Number(wageGroup),
            WorkerId: Number(worker)
        }
        apirpt.post("/getGspdreport/", slipDet,{
            headers: headers
        })
            .then(res => {
                setData(res.data);
                //console.log(res.data);
                setopenLoader(false);
            })
            .catch(error => {
                console.log("Error in hitting api : SlipGenDetails")
            })
    }

    useEffect(() => {
        getMRP();
        getEmployees();
        GetWages();
    }, [])

    return (
        <ThemeProvider theme={lightTheme}>
            <Grid container spacing={1} className="reports d-flex jc-space-bt mt-1">
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl variant="filled" className="reg-form--division-icon mt-05" fullWidth>
                        <FormDatePicker
                            id="FromDate"
                            placeholder="From Date"
                            label="From Date"
                            value={fromdate}
                            onChange={dateChangeEvent}
                            disablefuturedate={true}
                            required={true}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl variant="filled" className="reg-form--division-icon mt-05" fullWidth>
                        <FormDatePicker
                            id="ToDate"
                            placeholder="To Date"
                            label="To Date"
                            value={todate}
                            onChange={dateChangeEvent}
                        disablefuturedate={true}
                        required={true}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl className="width-100 reg-form--division-icon mt-05">
                        <InputLabel id="demo-simple-select-label">MRP Controller</InputLabel>
                        <Select
                            labelId="mrp-controller-label"
                            id="mrp-controller"
                            value={mrpController}
                            onChange={handleChange}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                mrp.map((h, i) =>
                                    (<MenuItem key={i} value={h.mrpcontrollerId}>{h.mrpcontroller}</MenuItem>))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl className="width-100 reg-form--division-icon mt-05">
                        <InputLabel id="demo-simple-select-label">Wage Group</InputLabel>
                        <Select
                            labelId="wage-group-label"
                            id="wageGroup"
                            value={wageGroup}
                            onChange={handleChangeWageGroup}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                wage.map((h, i) =>
                                    (<MenuItem key={i} value={h.wageGroupId}>{h.wageGroup}</MenuItem>))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={2} className="d-flex Width-100">
                    <FormControl className="width-100 reg-form--division-icon mt-05">
                        <InputLabel id="demo-simple-select-label">Worker</InputLabel>
                        <Select
                            labelId="worker-label"
                            id="worker"
                            value={worker}
                            onChange={handleChangeWorker}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                employee.map((h, i) =>
                                    (<MenuItem key={i} value={h.employeeId}>{h.empName}</MenuItem>))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={1} className="d-flex jc-flex-end">
                    <Tooltip title="Filter Data" placement="right" arrow onClick={SearchTable}>
                        <Button className="download-icon" startIcon={<FilterList />}>
                        </Button>
                    </Tooltip>
                </Grid>
                <Grid item xs={12}>
                    {iserror &&
                        <Alert severity="error">
                            {errorMessages.map((msg, i) => {
                                return <div key={i}>{msg}</div>
                            })}
                        </Alert>
                    }
                    <MaterialTable
                        title=""
                        columns={columns}
                        data={data}
                        icons={tableIcons}
                      
                        options={{
                            pageSizeOptions: [30, 40, 50],    // rows selection options
                            pageSize: 30,
                            filtering: false,
                            exportAllData: true,
                            exportButton: true,
                            maxBodyHeight: 600,
                        }}
                        editable={{
                            //onRowUpdate: (newData, oldData) =>
                            //    new Promise((resolve) => {
                            //        handleRowUpdate(newData, oldData, resolve);

                            //    }),
                            //onRowAdd: (newData) =>
                            //    new Promise((resolve) => {
                            //        handleRowAdd(newData, resolve)
                            //    }),
                            //onRowDelete: (oldData) =>
                            //    new Promise((resolve) => {
                            //        handleRowDelete(oldData, resolve)
                            //    }),
                        }}
                    />
                </Grid>
            </Grid>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
                id="templateUploadSuccess">
                <DialogTitle className={openClassName} style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {openType}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="clr-black">
                        {openAlert}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" autoFocus onClick={handleClose} className="ns-btn-secondary-light">
                        <span className="f-16 fw-bold">OK</span>
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openLoader}
                //onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
                id="templateUploadSuccess"
                PaperProps={{
                    style: {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        borderColor: "transparent"
                    },
                }}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </ThemeProvider>
    );
}

export default GSPDReport;